<template lang="pug">
  v-layout(row justify-center wrap fill-height)
    v-flex(xs12 md8)
      v-card.my-5
        v-layout
          v-flex(xs12).secondary--text
            v-container(grid-list-xl)
              v-layout(wrap justify-space-between style="margin:0 auto").text-xs-left
                v-flex(xs12)
                  h2.display-1: strong Contact
                  p Please contact us if you have any questions
                v-flex(xs12 md6 lg5 v-if="showContactform")
                  v-form
                    v-text-field(label="Name *" name="name" :rules="[v=>(!!v || 'Name is required')]")
                    v-text-field(label="Company" name="company")
                    v-text-field(label="Position" name="position")
                    v-text-field(label="Email *" type="email" name="email" :rules="[v=>(!!v || 'Email is required')]")
                    v-text-field(label="Phone" type="phone" name="phone")
                    v-textarea(label="Message *" name="message" :rules="[v=>(!!v || 'Message is required')]")
                    v-btn(block color="secondary") 
                      span Send
                      v-icon(right color="white") mdi-send
                v-flex(xs12 md6 lg4)
                  v-card(outlined)
                    v-card-text.black--text
                      v-layout(wrap)
                        v-flex(xs12).text-xs-center IAMIT
                        v-flex(xs12).secondary--text.text-xs-center: strong Cloud for growth
                        v-flex(xs6).primary--text.text-xs-right Website
                        v-flex(xs6) 
                          a(href="https://www.iamit.nl/") https://www.iamit.nl
                        v-flex(xs6).primary--text.text-xs-right Phone
                        v-flex(xs6) +31 (0)15 20 230 20
                        v-flex(xs6).primary--text.text-xs-right Email
                        v-flex(xs6) info@iamit.nl
                        v-flex(xs6).primary--text.text-xs-right Visit address
                        v-flex(xs6) Molslaan 121 <br/>2611 RK Delft
</template>
<script>
export default {
  data: () => ({
    //  Enable this if the backend is ready
    showContactform: false
  })
}
</script>